import { LOCAL_STORAGE_IMPERSONATING_USER_ID } from '../../../constants';

// "View app as" is stored as { userId, accountId } so it only applies to the
// account it was started on: localStorage is shared by every tab, and another
// tab on a different account must not send this user's view-as header.
// Older values are a bare user id with no account; those apply anywhere (the
// ImpersonatorProvider ends them if the user isn't on the account).
const getLocalStorageImpersonatorId = ({
  accountId,
}: {
  accountId: string | undefined;
}): string | null => {
  const stored = window.localStorage.getItem(
    LOCAL_STORAGE_IMPERSONATING_USER_ID,
  );
  if (!stored) {
    return null;
  }

  const impersonation = (() => {
    try {
      return JSON.parse(stored);
    } catch {
      return undefined;
    }
  })();
  if (
    !impersonation ||
    typeof impersonation !== 'object' ||
    typeof impersonation.userId !== 'string'
  ) {
    return stored;
  }

  return impersonation.accountId === accountId ? impersonation.userId : null;
};

export default getLocalStorageImpersonatorId;
